import React, { useEffect, useState } from "react";
import { NavbarBrand } from "reactstrap";
import DashboardConstant from "@views/Pages/Dashboard/landing-image.constant";
import { Link } from "react-router-dom";
import useThemeInitializer from "src/ThemeInitializer";

interface ThemeLogoFromCssVarProps {
    style?: React.CSSProperties;
    alt?: string;
    navbarColor?: string;
    className?: string;
    header?: boolean;
    src?: string;
}

const robotImages: Record<string, string> = {
    dabur: DashboardConstant.DaburWhite,
    secondary: DashboardConstant.Robot,
    underArmor: DashboardConstant.LoginRobot,
    default: DashboardConstant.WnnrLogoHeader,
};

export const useThemeName = () => {
    const [themeName, setThemeName] = useState(() => document.body.getAttribute("data-theme") || "dabur");
    useEffect(() => {
        const observer = new MutationObserver(() => {
            setThemeName(document.body.getAttribute("data-theme") || "dabur");
        });
        observer.observe(document.body, { attributes: true, attributeFilter: ["data-theme"] });
        return () => observer.disconnect();
    }, []);
    return themeName;
};

export const ThemeLogoFromCssVar: React.FC<ThemeLogoFromCssVarProps> = ({ style, alt = "logo", navbarColor, className, header, src }) => {
    const { theme } = useThemeInitializer();
    return (
        <NavbarBrand data-placement="bottom" to="/" title="WNNR.IN" tag={Link}>
            <img src={src ?? (alt === "hero" ? theme.logoImage1 : theme.logoUrl)} style={style} alt={alt} className={className} />
        </NavbarBrand>
    );
};

export const useImagePath = (header?: boolean): string => {
    const themeName = useThemeName();
    if (themeName === "dabur") {
        return header ? DashboardConstant.DaburWhite : DashboardConstant.Daburlogo;
    }
    if (themeName === "primary" && !header) {
        return DashboardConstant.Robot;
    }
    return robotImages[themeName] || robotImages.default;
};

export const useIsDaburTheme = (): boolean => useThemeName() === "dabur";
